<template>
    <div>
        <!--
        <a href="#" data-bs-toggle="modal" data-bs-target="#mdlForgotPassword">Forgot your password?</a>
    -->
        <!----------------------------------------------------------->

        <div class="modal fade" id="mdlForgotPassword" tabindex="-1">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="!send" class="modal-title modspec_title-small">
                            Forgot your password?
                        </h5>
                        <h5 v-else class="modal-title modspec_title-small">
                            Password change confirmation
                        </h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!send">
                            <div class="row">
                                <div class="col-sm-12">
                                    Enter your email to reset your password.
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-12">
                                    <input type="email" class="form-control" placeholder="Email"
                                        v-model="user.Username" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="row">
                                <div class="col-sm-12">
                                    <p>Please check your email to enter the new password</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" id="btnClosemdlForgotPassword"
                            data-bs-dismiss="modal">
                            Close
                        </button>

                        <loadingbutton v-if="!send" :loading="isLoading" @pressed="sendEmail" :disabled="isLoading"
                            buttonText="Send" />

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loadingbutton from "../../components/global/loading-button.vue";

export default {
    name: "forgot-client",
    components: {
        loadingbutton,
    },
    data: function () {
        return {
            user: { Username: "" },
            send: false,

            isLoading: false,
        };
    },
    mounted() { },
    methods: {
        sendEmail() {
            let self = this;
            self.isLoading = true;
            this.$vtc.vtcFetch("/Auth/ForgotPassword?username=" + this.user.Username, null,'API2').then(function () {
                self.send = true;
                self.isLoading = false;
            });

        },

    },
};
</script>

<style scoped></style>
